// Undo-Send-Fenster (P2.15): Sekunden zwischen dem Klick „Senden" und dem
// tatsächlichen Versand. In dieser Zeit kann der Nutzer über die Inline-Zeile
// „Rückgängig" abbrechen (0 Netzwerk-Calls). Rein clientseitig (localStorage),
// KEINE Migration, kein Server-State.
//
// `0` = Fenster aus → sofort senden (1 Klick = senden).
//
// Die UI bietet nur die Whitelist 0/5/7/10 an (kleines <select> im Composer-
// Footer). Der Getter akzeptiert BEWUSST jeden endlichen, nicht-negativen Wert:
// so kann ein Playwright-Walk ein kurzes, deterministisches Fenster setzen (z. B.
// 3 s), OHNE einen anderen Code-Pfad zu nehmen als Prod — die Fenster-Logik ist
// identisch, nur die Sekundenzahl variiert.
export const UNDO_SEND_STORAGE_KEY = "sb_mail_undo_window_s";
export const UNDO_SEND_DEFAULT_S = 7;

// Nur die WERTE. Die Beschriftung kommt aus dem Katalog
// (`mail.composer.rueckholzeitOption`, docs/i18n.md §3: „Nur Text in die
// Kataloge" — und umgekehrt kein Text in eine Tabelle, die keine Sprache kennt).
export const UNDO_SEND_OPTIONS: { value: number }[] = [
  { value: 0 },
  { value: 5 },
  { value: 7 },
  { value: 10 },
];

/** Aktuelles Rückhol-Fenster in Sekunden. Ungültig/fehlend → Default (7). */
export function getUndoWindowSeconds(): number {
  if (typeof localStorage === "undefined") return UNDO_SEND_DEFAULT_S;
  const raw = localStorage.getItem(UNDO_SEND_STORAGE_KEY);
  if (raw === null) return UNDO_SEND_DEFAULT_S;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : UNDO_SEND_DEFAULT_S;
}

export function setUndoWindowSeconds(v: number): void {
  if (typeof localStorage !== "undefined")
    localStorage.setItem(UNDO_SEND_STORAGE_KEY, String(v));
}
